import CircleCheck from 'components/icons/CircleCheck'
import RightRobotCard from 'components/cards/new/common/RightRobotCard'
import useWindowSize from 'components/util/useWindowSize'

const features = [
  '99.99% uptime',
  'Full developer docs, SDKs, CLI tools',
  'Bank-grade encryption',
  'Support Monday–Friday, 9am–6pm AEST',
]

const BuiltForDevs = () => {
  const size = useWindowSize()

  return (
    <RightRobotCard
      imageContainerWidth={size.isLgOrHigher ? '45%' : '100%'}
      image={{
        alt: 'Robot arm with developer tools',
        desktop: {
          dimensions: {
            height: 580,
            width: 481,
          },
          src: '/images/new/au/robot-arm-crop.png',
        },
        mobile: {
          dimensions: {
            height: 238,
            width: 361,
          },
          src: '/images/new/au/vo-sticker.png',
        },
      }}
      reverseColumnOrder
      overrideAllImageStyles
      imageStyle={{
        height: '100%',
        objectFit: 'cover',
        objectPosition: 'left',
      }}
    >
      <div className='d-flex flex-1 flex-column gap-4 ps-lg-24 px-4 pt-4 pb-5 py-lg-20 me-lg-n37'>
        <h2 className='fw-semibold fs-fluid-48-80 lh-105'>
          <span className='color-pink2'>Built for Developers</span> , Backed by
          Local Support
        </h2>
        <ul className='list-unstyled d-flex flex-column gap-3'>
          {features.map((feature, index) => (
            <li
              key={index}
              className='fs-fluid-18-26 fw-semibold lh-134 d-flex'
            >
              <CircleCheck
                fill='#30DB5B'
                className='me-2 mt-lg-2 flex-shrink-0 mt-1'
              />
              <span>{feature}</span>
            </li>
          ))}
        </ul>
      </div>
    </RightRobotCard>
  )
}

export default BuiltForDevs
